<template>
  <a-modal :visible="showDialog" :mask="true" :maskClosable="false" title="编辑" @ok="handleOk" @cancel="handleCancel()">
   <a-form layout="vertical">
     <a-form-item label="菜单">
       <a-input v-model="menuInfo.name" placeholder="菜单" />
     </a-form-item>
     <a-form-item label="父级菜单">
        <a-tree-select
          v-model="menuInfo.parent"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="menuList"
          allow-clear
          placeholder="父级菜单"
          treeNodeFilterProp ="title"
          show-search
          tree-default-expand-all
        >
        </a-tree-select>
     </a-form-item>
     <a-form-item label="图标">
       <a-input v-model="menuInfo.icon" placeholder="图标" />
     </a-form-item>
     <a-form-item label="链接">
       <a-input v-model="menuInfo.url" placeholder="链接" />
     </a-form-item>
     <a-form-item label="排序">
       <a-input v-model="menuInfo.sort" placeholder="排序" />
     </a-form-item>
     <a-form-item label="状态">
       <a-radio-group v-model="menuInfo.status">
          <a-radio-button value="1">
            启用
          </a-radio-button>
          <a-radio-button value="0">
            禁用
          </a-radio-button>
          <a-radio-button value="2">
            隐藏
          </a-radio-button>
        </a-radio-group>
     </a-form-item>
    
     
   </a-form>
  </a-modal>
</template>
<script>
import {OldgbMenuSave} from "../../api/v1/menu_api";

export default {
  name: "OldgbMenuEditDialog",
  props:['menuInfo','showDialog','menuList','type'],
  data(){
    return {
      expandedKeys:[]
    }
  },
  methods:{
    handleOk(){
      if (!this.menuInfo.parent && this.menuInfo.parent !== 0) {
        this.$message.error("请选择父级菜单")
        return false
      }
      if (!this.menuInfo.name) {
        this.$message.error("请填写菜单名称")
        return false
      }
      if (!this.menuInfo.sort) {
        this.menuInfo.sort = "0"
      }
      if (!this.menuInfo.status) {
        this.menuInfo.status = "1"
      }
      let data
      if (this.type == 'edit') {
        data = {
          "id":this.menuInfo.id,
          "name":this.menuInfo.name,
          "icon":this.menuInfo.icon,
          "url":this.menuInfo.url,
          "status":this.menuInfo.status,
          "parent":this.menuInfo.parent,
          "sort":this.menuInfo.sort,
        }
      } else {
        data = {
          "name":this.menuInfo.name,
          "icon":this.menuInfo.icon,
          "url":this.menuInfo.url,
          "status":this.menuInfo.status,
          "parent":this.menuInfo.parent,
          "sort":this.menuInfo.sort,
        }
      }
      OldgbMenuSave(data).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/OldgbMenuEditDialog.vue